export default __webpack_public_path__ + "static/media/supplierAssessmentCase.5e8a72f9.jpg";